import React from "react";
const Magnifier = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.768 16.786C14.0917 16.786 16.786 14.0917 16.786 10.768C16.786 7.44435 14.0917 4.75 10.768 4.75C7.44435 4.75 4.75 7.44435 4.75 10.768C4.75 14.0917 7.44435 16.786 10.768 16.786Z", stroke: "#000F0B", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M15.5861 15.5861L19.4881 19.4881", stroke: "#000F0B", "stroke-width": "1.5", "stroke-linecap": "round" })));
};
export default Magnifier;
